module.exports = __webpack_public_path__ + "files/6e206aaf897da820ca77b67803f918ea.png";